<section class="message-container">

  <img src="assets/img/FONDOMENSAJE.png" class="bg" />

  <div class="overlay">
    <img src="assets/img/CORAZON.png" class="heart" />

    <h1 class="title">Tu mensaje para nosotros</h1>

    <p class="subtitle">
      Cada palabra y cada deseo es<br />
      un recuerdo único para guardar<br />
      en el corazón
    </p>

    <button class="btn-message" (click)="openModal()">
      ESCRIBIR ACÁ
    </button>
  </div>

</section>

<!-- ✅ POPUP -->
@if (isModal) {
  <div class="modal-overlay" (click)="closeModal()">
    
    <div class="modal-card" (click)="$event.stopPropagation()">
      
      <button class="btn-close" (click)="closeModal()">X</button>

      <h3 class="modal-title">Dejanos tu mensaje</h3>

      <textarea 
        [(ngModel)]="mensaje"
        placeholder="Escribí tu mensaje..."
        class="input-message">
      </textarea>

      <button class="btn-send" (click)="guardarMensaje()">
        ENVIAR
      </button>

    </div>
  </div>
}